module.exports = __webpack_public_path__ + "media/images/photo05-e82c720ba8384c63f1bedeec0bd5de6a.png";